import { AxiosPromise, CancelToken } from "axios";
import { AxiosApiWrapper } from "../../../services/api/AxiosApiWrapper";
import { route } from "../../../shim/jsbridge";
import { Visualization } from "../@types";

class Api extends AxiosApiWrapper {
  getVisualization = (
    hash: string,
    cancelToken: CancelToken
  ): AxiosPromise<Visualization> =>
    this.get(route("api_file_visualization", [hash]), {
      cancelToken
    });

  getExpandedCloudDetails = (hashValue: string) =>
    this.get(
      route("api-sample-expanded-details-cloud", { hash_value: hashValue })
    );

  rescanSampleStatus = (hashValue: string) =>
    this.post(route("rescan_sample_status", { hash_value: hashValue }));

  rescanSample = (hashValue: string) =>
    this.post(route("rescan_sample", { hash_value: hashValue }));

  reclassifySample = (sha1: string) =>
    this.post(route("api-sample-reclassification", { hash_value: sha1 }));
}

export default new Api();
